import { createRepositoryToken } from '../../data/RepositoryProvider';

export interface ApiOperationsFilters {
  readonly endpoint: string;
  readonly statusClass: string;
}

export interface ApiOperationsMetric {
  readonly requestVolume: number;
  readonly errorRate: string;
  readonly p50LatencyMs: number;
  readonly p95LatencyMs: number;
  readonly p99LatencyMs: number;
}

export interface FailedApiSubmission {
  readonly id: string;
  readonly endpoint: string;
  readonly statusClass: string;
  readonly status: number;
  readonly partner: string;
  readonly errorCode: string;
  readonly occurredAt: string;
  readonly requestId: string;
}

export interface ApiOperationsSnapshot {
  readonly metric: ApiOperationsMetric;
  readonly failedSubmissions: readonly FailedApiSubmission[];
}

export interface ApiOperationsRepository {
  getSnapshot(filters: ApiOperationsFilters, signal: AbortSignal): Promise<ApiOperationsSnapshot>;
}

export const apiOperationsRepositoryToken =
  createRepositoryToken<ApiOperationsRepository>('apiOperations');

const failures = Object.freeze<readonly FailedApiSubmission[]>([
  {
    id: 'mock-api-failure-1',
    endpoint: 'POST /api/v1/transactions',
    statusClass: '4xx',
    status: 422,
    partner: 'Alpha Partner',
    errorCode: 'VALIDATION_FAILED',
    occurredAt: '2026-07-22T10:30:00+07:00',
    requestId: 'mock-api-req-001',
  },
  {
    id: 'mock-api-failure-2',
    endpoint: 'GET /api/v1/transactions',
    statusClass: '5xx',
    status: 503,
    partner: 'Beta Partner',
    errorCode: 'SERVICE_UNAVAILABLE',
    occurredAt: '2026-07-22T10:42:00+07:00',
    requestId: 'mock-api-req-002',
  },
]);

export class MockApiOperationsRepository implements ApiOperationsRepository {
  async getSnapshot(filters: ApiOperationsFilters, signal: AbortSignal) {
    if (signal.aborted) throw new DOMException('Aborted', 'AbortError');
    return {
      metric: {
        requestVolume: 128_450,
        errorRate: '0.84%',
        p50LatencyMs: 84,
        p95LatencyMs: 242,
        p99LatencyMs: 610,
      },
      failedSubmissions: failures.filter(
        (item) =>
          (filters.endpoint === '' || item.endpoint === filters.endpoint) &&
          (filters.statusClass === '' || item.statusClass === filters.statusClass),
      ),
    };
  }
}
